import UserContentItemWithLocation from '../UserContentItemWithLocation';

class UserContentCopiedText extends UserContentItemWithLocation {
  static typeName = 'copiedTexts';

  snippet;
  #charCount;

  constructor(properties = {}) {
    super(...arguments);

    this.snippet = properties.snippet;

    // If this instance was created from a backend record
    // (i.e. not a new unsaved instance),
    // then the backend is in charge of counting the characters.
    //
    // It should be the same for all intents and purposes,
    // but the backend is technically canonical.
    this.#charCount = properties.charCount;
  }

  serialize() {
    const { snippet } = this;

    return {
      ...super.serialize(),

      snippet,
    };
  }

  get charCount() {
    return this.#charCount ?? this.snippet?.length ?? 0;
  }

  get truncatedSnippet() {
    return this.constructor.getTruncatedSnippet(this.snippet);
  }

  async persist({ createMutation }) {
    if (this.isPersistedOnce) {
      return null;
    }

    const {
      data: { createCopiedText },
    } = await createMutation({
      variables: {
        input: {
          text: this.snippet,
          ...this.locationPropertiesForGraphQL,
        },
      },
    });

    return createCopiedText.copiedText.id;
  }
}

export default UserContentCopiedText;
